import { App } from "./App.1";

export default App;
